// @flow weak

import {GET, apiBase} from '../helpers/request';
import _ from 'lodash/fp';

export const GET_FILTERS_REQUEST = '@exports/GET_FILTERS_REQUEST';
export const GET_FILTERS_SUCCESS = '@exports/GET_FILTERS_SUCCESS';
export const GET_FILTERS_FAILURE = '@exports/GET_FILTERS_FAILURE';

export const FETCH_DATA_REQUEST = '@exports/FETCH_DATA_REQUEST';
export const FETCH_DATA_SUCCESS = '@exports/FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAILURE = '@exports/FETCH_DATA_FAILURE';

export const SET_FILTER = '@exports/SET_FILTER';

export const request = type => ({
  type,
});

export const requestSuccess = (type, data = null) => ({
  type,
  data,
});

export const requestError = (type, error) => ({
  type,
  error,
});

const buildQueryString = currentSelection => {
  const {projects, suppliers, productTypes, workerTypes, roomTypes, assortments} = currentSelection;
  const flatten = items => Array.isArray(items) ? _.join(',', _.map('id', items)) : null;
  let query = `projects=${flatten(projects)}` +
    `&suppliers=${flatten(suppliers)}` +
    `&productTypes=${flatten(productTypes)}` +
    `&workerTypes=${flatten(workerTypes)}` +
    `&roomTypes=${flatten(roomTypes)}`;

  if (assortments) {
    query = `${query}&assortments=${flatten(assortments)}`;
  }
  return query;
};

export const fetchData = currentSelection => async dispatch => {
  dispatch(request(FETCH_DATA_REQUEST));
  try {
    const query = buildQueryString(currentSelection);

    const data = await GET({endpoint: `/dataexports/?${query}`}, dispatch);
    dispatch(requestSuccess(FETCH_DATA_SUCCESS, {...currentSelection, rows: data, downloadUri: `${apiBase}/dataexports/download/?${query}`}));
  } catch (err) {
    dispatch(requestError(FETCH_DATA_FAILURE, err));
  }
};

export const fetchFilters = () => async dispatch => {
  dispatch(request(GET_FILTERS_REQUEST));
  try {
    const filters = await GET({endpoint: '/dataexports/filters'}, dispatch);
    dispatch(requestSuccess(GET_FILTERS_SUCCESS, filters));
  } catch (err) {
    dispatch(requestError(GET_FILTERS_FAILURE, err));
  }
};



// WEBPACK FOOTER //
// ./src/actions/exportsView.js